import React from 'react';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Componentes
import SettingsInfo from './SettingsInfo';

function SettingsInfoContainer() {
    const { settings } = useGlobalContext();

    return <SettingsInfo states={{ settings }} />;
}

export default SettingsInfoContainer;
